module.exports = __webpack_public_path__ + "static/cp-eb9c3980e451f3efc800a292b67c9a99.svg";